"use client";

import { useEffect } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import * as Sentry from "@sentry/nextjs";
import { useUserInfo } from "@/app/[locale]/hooks";
import { getEnv, shareCodeKey } from "@/00-shared/const";
export const previousUrlKey = "previousUrl";
export function NavigationEvents() {
  const isProd = getEnv() === "prod";
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const isHomePageOrBindPhone = ["/", "/zh", "/en", "/bindPhone"].includes(pathname);
  const {
    user
  } = useUserInfo();
  const source = searchParams.get("s");
  useEffect(() => {
    if (source) {
      Sentry.setTag("user_source", source);
    }
  }, [source]);

  // 如果当前页面不是首页或绑定手机页，且用户没有绑定手机，则跳转到绑定手机页
  useEffect(() => {
    if (!isHomePageOrBindPhone && !user?.phone && user?.id) {
      router.push("/bindPhone");
    }
  }, [isHomePageOrBindPhone, user?.phone]);
  useEffect(() => {
    const url = `${pathname}?${searchParams}`;
    return () => {
      window.sessionStorage.setItem(previousUrlKey, url);
    };
  }, [pathname, searchParams]);
  useEffect(() => {
    if (!isProd) {
      return;
    }
    const uuid = localStorage.getItem("anonymousUuid");
    // NavigationEvents InitStateProvider是并发渲染的
    // 未避免重复上报，等待获取了用户id在执行上报
    if (user?.id) {
      const requestBody = {
        pathname,
        timestamp: Date.now(),
        searchParams: searchParams.toString(),
        browser_date: new Date().toLocaleString(),
        user_id: user?.id ?? uuid,
        user_source: source,
        user_type: user?.id ? "registered" : "anonymous",
        anonymous_id: uuid,
        referrer: window.document.referrer
      };
      fetch("/api/pageViewReport", {
        method: "POST",
        body: JSON.stringify(requestBody),
        headers: {
          "Content-Type": "application/json"
        }
      });
    }
  }, [pathname, user?.id, source, isProd, searchParams]);

  // 禁止next-route-announcer的自动翻译，否则react组件销毁会报错
  useEffect(() => {
    const announcer = document.querySelector("next-route-announcer");
    if (announcer && announcer.shadowRoot) {
      const div = announcer.shadowRoot.querySelector("#__next-route-announcer__");
      if (div) {
        div.setAttribute("translate", "no");
      }
    }
    // 存储邀请码
    const shareCode = searchParams.get(shareCodeKey);
    if (shareCode) {
      sessionStorage.setItem(shareCodeKey, shareCode);
    }
  }, []);
  return <></>;
}